import React from 'react';
import { ArrowRight } from 'lucide-react';
import { infoCards } from '../mockData';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const InfoCards = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {infoCards.map((card) => (
            <Card 
              key={card.id} 
              className="overflow-hidden border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold text-[#0A1F3B] mb-3">
                  {card.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {card.description}
                </p>
                <Button 
                  variant="link" 
                  className="text-[#00ACC1] hover:text-[#0097A7] p-0 font-semibold group"
                >
                  {card.link}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoCards;